import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

export async function selectUserLocale(userId: string): Promise<string | null> {
    const { data, error } = await supabaseClient
        .from("users")
        .select("preferred_locale")
        .eq("user_id", userId)
        .maybeSingle();

    if (error) throw error;
    return data?.preferred_locale ?? null;
}

export const userLocaleQueryOptions = (userId: string) =>
    queryOptions({
        queryKey: ["user-locale", userId],
        queryFn: () => selectUserLocale(userId),
        enabled: Boolean(userId),
    });

export function useUserLocaleQuery(userId: string) {
    return useQuery(userLocaleQueryOptions(userId));
}
